<div class="page-content-wrapper">
  <!-- Dashboard Cards -->
  <div v-if="user_role === 'ClientAdmin'" class="row g-4 mb-4">
    <div class="col-sm-12 col-md-4">
      <icon-card title="Active Services" :count="active_services" icon_class="fa fa-cogs"/>
    </div>
    <div class="col-sm-12 col-md-4">
      <icon-card title="Passed Verifications" :count="passed_verifications" icon_class="far fa-check-circle"/>
    </div>
    <div class="col-sm-12 col-md-4">
      <icon-card title="Failed Verifications" :count="failed_verifications" icon_class="fas fa-exclamation-circle"/>
    </div>
  </div>

  <!-- Services Card -->
  <div class="card rounded-3 border-1 shadow">
    <div
      class="card-header bg-white border-0 me-2 d-flex justify-content-between align-items-center"
    >
      <p class="text-s fw-bold mb-0">Your Services</p>
      <!-- {{ approved_requests }} -->
      <div class="d-flex align-items-center gap-3">
        <!-- Add Service Button -->
        <router-link
          :to="{ name: 'instant_services' }"
          v-if="user_role === 'ClientAdmin'"
          class="nav-link text-dark p-0"
        >
        <button
          type="button"
          class="btn bg-dark btn-sm text-xs rounded-3 text-white shadow"
        >
          <i class="fas fa-plus"></i> Add Service
        </button>
        </router-link>
        <!-- Search Bar -->
        <SearchBar
          v-model="searchQuery"
          placeholder="Search services..."
          label="Search"
          @update:modelValue="filterServices"
        />
      </div>
    </div>
    <div class="card-body">
      <!-- Loading Spinner -->
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <!-- Services Section with Grid Layout -->
      <div v-else class="approved-services-section">
        <!-- No Services Available -->
        <div v-if="!loading && approved_requests.length === 0 && !searchQuery" class="empty-state-container">
          <i class="fas fa-inbox fa-4x text-muted mb-3"></i>
          <h5 class="text-muted">No Services Available</h5>
          <p class="text-muted">You don't have any services yet. Add services to get started.</p>
          <router-link
            v-if="user_role === 'ClientAdmin'"
            :to="{ name: 'instant_services' }"
            class="btn bg-green text-dark rounded-3 mt-2"
          >
            <i class="fas fa-plus"></i> Add Service
          </router-link>
        </div>

        <!-- Categories with Services Grid -->
        <div v-else>
          <div v-for="(category, index) in filteredCategories" :key="category.id">
          
          <!-- Category Filter Badges - Only for Inactive Services -->
          <div v-if="category.id === 4 && availableServiceCategories.length > 0" class="category-badges-container">
            <button
              class="category-badge"
              :class="{ active: selectedServiceCategory === null }"
              @click="selectServiceCategory(null)"
            >
              All
            </button>
            <button
              v-for="cat in availableServiceCategories"
              :key="cat.id"
              class="category-badge"
              :class="{ active: selectedServiceCategory === cat.id }"
              @click="selectServiceCategory(cat.id)"
            >
              {{ cat.name }}
            </button>
          </div>

          <div class="category-container">
            <!-- Category Header -->
            <div class="category-header">
              <span class="category-name">{{ category.name }}</span>
              <a 
                href="#" 
                class="show-all-link"
                @click.prevent="toggleCategory(category.id)"
                v-if="shouldShowMoreButton(category)"
              >
                {{ isCategoryExpanded(category.id) ? 'Show less' : 'Show more' }}
              </a>
            </div>
            <transition-group name="slide-up-fade" tag="div" class="services-grid">
              <InstantServiceCard
                v-for="service in getDisplayedServices(category)"
                :key="service.service_id"
                :service-name="service.service_name"
                :service="service"
                :disabled="service.isActive === false"
                :category="category.name"
                @utilize="utilize_service(service.service_id)"
                @request="handleServiceRequest"
              />
            </transition-group>
          </div>
        </div>

        <!-- Empty State for Search -->
        <div v-if="!loading && searchQuery && filteredCategories.length === 0" class="empty-state-container">
          <i class="fas fa-search fa-4x text-muted mb-3"></i>
          <h5 class="text-muted">No Results Found</h5>
          <p class="text-muted">No services found matching "{{ searchQuery }}"</p>
        </div>
        </div>
      </div>
    </div>
</div>

<div class="modal" tabindex="-1" id="service_modal">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="close_modal"
        ></button>
      </div>
      <div class="modal-body">
        <component :is="service_map[selected_service]"></component>
      </div>
    </div>
  </div>
</div>
</div>
